import {
  type ScanActionExecutionRegistry,
  type ScanActionExecutor,
} from '../types/scanAction.type';

/** Stores the active route executor for each scan action. */
export const createScanActionExecutionRegistry = (): ScanActionExecutionRegistry => {
  const entries = new Map<string, Map<symbol, ScanActionExecutor>>();

  const release = (name: string, token: symbol) => {
    const registrations = entries.get(name);
    if (!registrations) return;

    registrations.delete(token);
    if (!registrations.size) entries.delete(name);
  };

  return {
    execute: (name, scanEvent) => {
      const registrations = entries.get(name);
      const executor = registrations && Array.from(registrations.values()).pop();
      if (!executor) throw new Error(`No active scan action executor for ${name}`);

      executor(scanEvent);
    },
    has: (name) => Boolean(entries.get(name)?.size),
    register: (name, executor) => {
      const token = Symbol('scanActionExecutionRegistration');
      const registrations = entries.get(name) ?? new Map<symbol, ScanActionExecutor>();
      registrations.set(token, executor);
      entries.set(name, registrations);

      return {
        release: () => release(name, token),
        update: (nextExecutor) => {
          if (entries.get(name)?.has(token)) entries.get(name)?.set(token, nextExecutor);
        },
      };
    },
    release,
    reset: () => entries.clear(),
  };
};
